import request from '../request'

// 获取首页信息
export function getHomeInfo() {
  return request({
    url: '/app/info',
    method: 'get',
  })
}

// 获取首页轮播图列表
export function getHomeLunboList(params) {
  return request({
    url: '/app/lunbo/list',
    method: 'get',
    params,
  })
}

// 获取文章栏目列表
export function getArticleBlocks(params) {
  return request({
    url: '/app/article/blocks',
    method: 'get',
    params,
  })
}

// 获取文章分页列表
export function getArticleList(params) {
  return request({
    url: '/app/article/list',
    method: 'get',
    params,
  })
}

// 获取文章详情
export function getArticleDetail(params) {
  return request({
    url: '/app/article/detail',
    method: 'get',
    params,
  })
}
